import client, { API_BASE_URL } from './client';
import publicClient from './publicClient';

// QR오더 화면(고객용)에서 쓰던 리뷰 작성 함수(createProductReview/createStoreReview)는
// front-web(고객용 웹서비스)의 api/qrOrder.js 로 이관되었다 - 화면 자체가 그쪽으로
// 옮겨갔기 때문이다. 아래 공개 조회 함수는 그대로 admin-web에도 남겨둔다
// (관리자 화면에서 공개 리뷰를 참고 조회할 수 있도록 - 현재는 어디서도 호출하지 않는다).

export async function getPublicProductReviews(productId, params = {}) {
  const res = await publicClient.get(`/admin/review/public/product/${productId}`, { params });
  return res.data;
}

export async function getPublicStoreReviews(storeId, params = {}) {
  const res = await publicClient.get(`/admin/review/public/store/${storeId}`, { params });
  return res.data;
}

// ===================== 관리자용 (리뷰관리 화면) =====================

export async function getAdminProductReviews(params) {
  const res = await client.get('/admin/review/product', { params });
  return res.data;
}

export async function updateProductReviewVisibility(productReviewId, useYn, updatedBy) {
  const res = await client.put(`/admin/review/product/${productReviewId}/visibility`, { useYn, updatedBy });
  return res.data;
}

export async function deleteProductReview(productReviewId) {
  const res = await client.delete(`/admin/review/product/${productReviewId}`);
  return res.data;
}

export async function getAdminStoreReviews(params) {
  const res = await client.get('/admin/review/store', { params });
  return res.data;
}

export async function updateStoreReviewVisibility(storeReviewId, useYn, updatedBy) {
  const res = await client.put(`/admin/review/store/${storeReviewId}/visibility`, { useYn, updatedBy });
  return res.data;
}

export async function updateStoreReviewReward(storeReviewId, rewardGivenYn, updatedBy) {
  const res = await client.put(`/admin/review/store/${storeReviewId}/reward`, { rewardGivenYn, updatedBy });
  return res.data;
}

export async function deleteStoreReview(storeReviewId) {
  const res = await client.delete(`/admin/review/store/${storeReviewId}`);
  return res.data;
}

/**
 * 리뷰관리 화면 실시간 갱신용 SSE 스트림 URL
 * 포스에서 알려줘요" 참고). 브라우저 EventSource 는 커스텀 헤더(Authorization)를 보낼 수
 * 없으므로, 직원호출관리와 동일하게 JWT를 "?token=" 쿼리파라미터로 실어보낸다.
 */
export function reviewStreamUrl(accessToken) {
  return `${API_BASE_URL}/admin/review/stream?token=${encodeURIComponent(accessToken || '')}`;
}
